import React, { useState, useEffect } from 'react';
import Navbar from '../Components/Navbar';
import HeroSection from '../Components/HeroSection';
import SearchForm from '../Components/SearchForm';
import Suggestions from '../Components/Suggestions';
import SearchResults from '../Components/SearchResults';
import CustomeAlertBox from '../Components/CustomeAlertBox';
import { apiCall } from '../utills/APICall';
import { getUserIP } from '../utills/IPRequester';
import styles from '../search.module.css';
import GeneralLayout from '../layout/GeneralLayout';

export default function Search() {
  const [searchQuery, setSearchQuery] = useState('');
  const [showResults, setShowResults] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [results, setResults] = useState([]);
  const [userIp, setUserIp] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const fetchUserIP = async () => {
      try {
        const ip = await getUserIP();
        setUserIp(ip);
      } catch (error) {
        console.error('Error fetching user IP:', error);
      }
    };
    fetchUserIP();
  }, []);

  const fetchSuggestions = async (query) => {
    try {
      const response = await apiCall(`suggestions?domain=${query}`, 'GET');
      console.log('Raw API Response:', response);
      if (response && response.success && response.data && Array.isArray(response.data.data)) {
        console.log('Setting suggestions:', response.data.data);
        setSuggestions(response.data.data);
      } else {
        console.log('No valid suggestions');
        setSuggestions([]);
      }
    } catch (error) {
      console.error('Error fetching suggestions:', error);
      setSuggestions([]);
    }
  };

  const handleInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.length >= 3) {
      fetchSuggestions(query);
    } else {
      setSuggestions([]);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    searchWithDomain(searchQuery);
  };

  const searchWithDomain = async (domain) => {
    setSuggestions([]);
    try {
      if (!userIp) {
        console.error('Unable to get user IP. Blocking request.');
        setResults([]);
        setShowResults(true);
        return;
      }

      const response = await apiCall('email-pattern', 'POST', {
        domain: domain,
        userIp: userIp
      });

      if (response && response.success && response.data.data) {
        setResults([response.data.data]);
        setSuggestions([]);
      } else if (!response.success) {
        setErrorMessage(response.message);
        setResults([]);
      }
      setShowResults(true);
    } catch (error) {
      setErrorMessage('Something went wrong!');
      setResults([]);
      setShowResults(true);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchQuery(suggestion);
    searchWithDomain(suggestion);
  };

  const closeAlert = () => {
    setErrorMessage('');
  };

  return (
    <GeneralLayout>
      <HeroSection>
        <SearchForm
          searchQuery={searchQuery}
          handleInputChange={handleInputChange}
          handleSearch={handleSearch}
        />
        {searchQuery.length >= 3 && suggestions.length > 0 && !showResults && (
          <Suggestions suggestions={suggestions} onSuggestionClick={handleSuggestionClick} />
        )}
        <SearchResults results={results} showResults={showResults} />
        {errorMessage && <CustomeAlertBox message={errorMessage} onClose={closeAlert} />}
      </HeroSection>
    </GeneralLayout>
  );
}
